enum Role {
  User = "User",
  ServiceAdministrator = "ServiceAdministrator",
}

export default Role;